"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Remodel() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="18804" id="bathroom-remodel-services-in-lakeland-fl" className="bg-background text-foreground py-28 md:py-44 px-6 md:px-12">
      <div className="max-w-[1240px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
          {}
          <div ref={imageRef} className="md:col-span-5 transition-all ease-out" style={{
          opacity: imageVisible ? 1 : 0,
          transform: imageVisible ? "scale(1)" : "scale(1.02)",
          transitionDuration: "900ms"
        }}>
            <div className="overflow-hidden rounded-lg shadow-lg">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/luxury_bathroom_remodel.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/luxury_bathroom_remodel.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709164/img/luxury_bathroom_remodel.webp-wvc-sizes" alt="A modern, high-end bathroom remodel in Lakeland featuring clean tile work and premium fixtures" loading="lazy" decoding="async" className="w-full h-full object-cover aspect-[4/5]" />
            </div>
          </div>

          {}
          <div ref={contentRef} className="md:col-span-7 md:pl-4 lg:pl-8">
            {}
            <div className="transition-all ease-out" style={{
            opacity: contentVisible ? 1 : 0,
            transform: contentVisible ? "translateY(0)" : "translateY(12px)",
            transitionDuration: "720ms",
            transitionDelay: "0ms",
            transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)"
          }}>
              <span className="font-default text-[0.8125rem] font-medium tracking-[0.14em] uppercase text-muted-foreground">Bathroom Remodel Lakeland FL</span>
            </div>

            {}
            <h1 className="font-default text-foreground mt-5 transition-all ease-out !text-6xl" style={{
            fontSize: "clamp(2.5rem, 5.6vw, 4.75rem)",
            fontWeight: 600,
            letterSpacing: "-0.02em",
            lineHeight: 1.05,
            opacity: contentVisible ? 1 : 0,
            transform: contentVisible ? "translateY(0)" : "translateY(12px)",
            transitionDuration: "720ms",
            transitionDelay: "90ms",
            transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)"
          }}>Bathroom Remodel Lakeland FL</h1>

            {}
            <p className="font-default text-foreground mt-8 max-w-[480px] transition-all ease-out" style={{
            fontSize: "clamp(1.125rem, 1.3vw, 1.3125rem)",
            fontWeight: 400,
            letterSpacing: "-0.005em",
            lineHeight: 1.6,
            opacity: contentVisible ? 1 : 0,
            transform: contentVisible ? "translateY(0)" : "translateY(12px)",
            transitionDuration: "720ms",
            transitionDelay: "180ms",
            transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)"
          }}>Request a free bathroom remodel quote in Lakeland, FL. Get help with bathroom updates, renovations, showers, tubs, tile, flooring, vanities, fixtures, and layout improvements.</p>

            {}
            <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-8 transition-all ease-out" style={{
            opacity: contentVisible ? 1 : 0,
            transform: contentVisible ? "translateY(0)" : "translateY(12px)",
            transitionDuration: "720ms",
            transitionDelay: "270ms",
            transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)"
          }}>
              <Button asChild size="lg" className="rounded-lg px-7 py-6 h-auto bg-primary text-primary-foreground hover:bg-primary/90 font-default text-[0.9375rem] font-medium transition-colors duration-200">
                <Link to="/Contact">Request a Free Quote</Link>
              </Button>

              <Link to="/Services" className="group inline-flex items-center gap-2 font-default text-[0.9375rem] font-medium text-foreground">
                <span className="border-b border-border group-hover:border-primary group-hover:text-primary transition-colors duration-200 pb-1">
                  View our services
                </span>
                <ArrowRight className="w-4 h-4 group-hover:text-primary transition-colors duration-200" />
              </Link>
            </div>

            {}
            <div className="mt-12 transition-all ease-out" style={{
            opacity: contentVisible ? 1 : 0,
            transform: contentVisible ? "translateY(0)" : "translateY(12px)",
            transitionDuration: "720ms",
            transitionDelay: "360ms",
            transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)"
          }}>
              <div className="flex flex-wrap items-center gap-x-3 gap-y-2 font-default text-sm text-muted-foreground">
                <span className="">Bathroom Remodel Quotes</span>
                <span aria-hidden="true" className="text-muted-foreground/60">·</span>
                <span>Lakeland, FL</span>
                <span aria-hidden="true" className="text-muted-foreground/60">·</span>
                <span>Polk County</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}